module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hans_3-af9c365106df247dd892c5f02e1a3a48.jpg";